package com.mrpowergamerbr.puppydough

import web.cssom.ClassName
import web.dom.Element
import web.dom.ParentNode
import web.dom.clickEvent
import web.events.addHandler
import web.html.HTMLCanvasElement
import web.html.HTMLDivElement
import web.html.HtmlTagName

fun ParentNode.clickToStart(gameContainer: Element, gameCanvas: HTMLCanvasElement, onClick: HTMLDivElement.() -> Unit = {}) {
    this.el(HtmlTagName.div) {
        className = ClassName("click-to-start undertale-text-button")
        textContent = "[CLICK TO START]"

        this.clickEvent.addHandler {
            plausible("Game Launched")

            remove()

            showGameCanvas(gameContainer, gameCanvas)

            onClick(this)
        }
    }
}

fun showGameCanvas(gameContainer: Element, gameCanvas: HTMLCanvasElement) {
    gameContainer.append(gameCanvas)
    gameContainer.classList.add(ClassName("started"))
}